<script>
    const styles = 'font-size: 2em; font-family: Dosis, sans-serif;  color: black; background-color: white'
    function log(msg) {
        console.log(`%c${msg}`, styles)
    }
    log('  Hello, nice to meet you!  ')
</script>